import Swal from 'sweetalert2'
import {openErrorNotification} from '../../js/helpers/notifications'
import {closeModalHelper, openModalHelper, toggleElement} from '../../js/helpers/modals'

export default () => {
  let $ = jQuery
  let inquiryBtns = document.querySelectorAll('.js-inquiry-property')
  initInquiryBtns(inquiryBtns)

  // Load Photo
  const loadPhoto = document.querySelector('.js-add-avatar')
  const photoInput = document.querySelector('.profile__avatar input[type="file"]')
  const profileAvatarWrapper = document.querySelector('.profile__avatar')

  if (loadPhoto) {
    loadPhoto.addEventListener('click', () => photoInput.click())
  }
  if (photoInput) {
    photoInput.addEventListener('change', event => {
      const allowedExtension = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp']

      if (
        event.target.files[0] &&
        allowedExtension.includes(event.target.files[0].type) &&
        event.target.files[0].size / 1048576 < 5
      ) {
        const fileFormData = new FormData()

        fileFormData.append('action', 'updateProfile')
        fileFormData.append('avatar', event.target.files[0])

        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          type: 'POST',
          processData: false,
          contentType: false,
          data: fileFormData,
          beforeSend: function () {
            profileAvatarWrapper.classList.add('loading')
          },
          success: function (response) {
            if (response.data.status === 'success') {
              $('.profile__avatar').css('border', 'none')

              $(profileAvatarWrapper)
                .find('div:first-child')
                .empty()
                .prepend(`<img style="border-radius: 50%" src="${response.data.image}">`)
            } else {
              openErrorNotification()
            }
          },
          error: function (error) {
            openErrorNotification()
            console.log(error)
          },
          complete: function (data) {
            profileAvatarWrapper.classList.remove('loading')
          }
        })
      } else {
        openErrorNotification('Sorry, this file cannot be uploaded')
      }
    })
  }

  // Update User Profile
  const profileForm = document.querySelector('.js-profile-form-edit')

  if (profileForm) {
    profileForm.addEventListener('submit', event => {
      event.preventDefault()

      const profileFormData = $(profileForm).serializeArray()

      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
          action: 'updateProfile',
          data: profileFormData
        },
        beforeSend: function () {
          profileForm.classList.add('loading')
        },
        success: function (response) {
          if (response.data.status === 'success') {
            openErrorNotification('Profile updated successfully', ' ', false)
            window.location = '/profile'
          } else {
            openErrorNotification(response.data.message, '', true)
          }
        },
        error: function (error) {
          openErrorNotification()
          console.log(error)
        },
        complete: function (data) {
          profileForm.classList.remove('loading')
        }
      })
    })
  }

  // Filters
  const filterForm = document.querySelector('.js-profile-filters')
  const propertiesWrapper = document.querySelector('.js-properties__wrapper')
  const propertiesPaginationWrapper = document.querySelector('.properties__pagination')

  if (filterForm && propertiesWrapper) {
    filterForm.addEventListener('submit', event => {
      event.preventDefault()
      const filterFormData = $(filterForm).serializeArray()

      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
          action: 'filterProperties',
          data: filterFormData
        },
        beforeSend: function () {
          propertiesWrapper.classList.add('loading')
          filterForm.classList.add('loading')
        },
        success: function (response) {
          if (response.data.status === 'success') {
            propertiesWrapper.innerHTML = response.data.properties
            propertiesPaginationWrapper.innerHTML = response.data.pagination
            $('.properties__pagination').data('max-page', response.data.maxpages)
            initPagination()
            inquiryBtns = document.querySelectorAll('.js-inquiry-property')
            initInquiryBtns(inquiryBtns)
          } else {
            openErrorNotification()
          }
        },
        error: function (error) {
          openErrorNotification()
          console.log(error)
        },
        complete: function (data) {
          setTimeout(() => {
            propertiesWrapper.classList.remove('loading')
            filterForm.classList.remove('loading')
          }, 300)
        }
      })
    })
  }

  // Pagination
  function initPagination() {
    let propertiesPagination = document.querySelector('.properties__pagination')

    if (propertiesPagination) {
      let pageNumber = 1
      const PROPERTY_PER_PAGE = 10
      const maxPageNumber = propertiesPagination.dataset.maxPage
      const paginationNumbers = propertiesPagination.querySelectorAll('.pagination-page-number')
      const paginationPrevBtn = propertiesPagination.querySelector('.js-pagination-prev')
      const paginationNextBtn = propertiesPagination.querySelector('.js-pagination-next')
      const paginationCount = propertiesPagination.querySelector('.pagination__count')
      const paginationSkip = propertiesPagination.querySelector('.pagination__skip')

      const getPage = newValue => {
        if (newValue === pageNumber) return

        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          type: 'POST',
          data: {
            action: 'paginateProperties',
            data: [
              {
                page: newValue,
                filter: $(filterForm).serializeArray()
              }
            ]
          },
          beforeSend: () => {
            propertiesWrapper.classList.add('loading')
            filterForm.classList.add('loading')
          },
          success: response => {
            if (response.data.status === 'success') {
              propertiesWrapper.innerHTML = response.data.properties
              $('.properties__pagination p span:first-child').text(response.data.pagination)

              document.querySelector(`.pagination-page-number[data-page="${newValue}"]`).classList.add('active')
              document.querySelector(`.pagination-page-number[data-page="${pageNumber}"]`).classList.remove('active')

              if (newValue === 1) {
                $('.js-pagination-prev').addClass('blocked')
              } else {
                $('.js-pagination-prev').removeClass('blocked')
              }

              let maxPageNumbers = $('.properties__pagination').data('max-page')

              if (newValue === maxPageNumbers) {
                $('.js-pagination-next').addClass('blocked')
              } else {
                $('.js-pagination-next').removeClass('blocked')
              }

              document.querySelector('.pagination-page-number.active').scrollIntoView({
                behavior: 'instant',
                block: 'nearest',
                inline: 'center'
              })

              pageNumber = newValue

              inquiryBtns = document.querySelectorAll('.js-inquiry-property')
              initInquiryBtns(inquiryBtns)
            } else {
              console.log(response)
              openErrorNotification()
            }
          },
          error: error => {
            console.log(error)
            openErrorNotification()
          },
          complete: data => {
            setTimeout(() => {
              window.scrollTo({top: 0, behavior: 'smooth'})
              setTimeout(() => {
                propertiesWrapper.classList.remove('loading')
                filterForm.classList.remove('loading')
              }, 500)
            }, 300)
          }
        })
      }

      $('.properties__pagination').on('click', '.pagination-page-number', event => {
        getPage(parseInt(event.target.dataset.page))
      })

      if (paginationNextBtn) {
        $('.properties__pagination').on('click', '.js-pagination-next', () => {
          pageNumber = $('.pagination-page-number.active').data('page')
          getPage(parseInt(pageNumber) + 1)
        })
      }

      if (paginationPrevBtn) {
        $('.properties__pagination').on('click', '.js-pagination-prev', () => {
          pageNumber = $('.pagination-page-number.active').data('page')
          getPage(parseInt(pageNumber - 1))
        })
      }
    }
  }

  initPagination()

  // Tabs
  const profileTabs = document.querySelectorAll('.profile-tab:not(:last-child)')
  const profileTabsContent = document.querySelectorAll('.profile-tab__content-item')

  profileTabs.forEach(item => {
    item.addEventListener('click', () => {
      item.parentNode.querySelector('.profile-tab.active').classList.remove('active')
      profileTabsContent.forEach(tabItem => {
        tabItem.classList.remove('active')
        if (tabItem.dataset.tab === item.dataset.tab) {
          tabItem.classList.add('active')
        }
      })

      item.classList.add('active')
    })
  })

  if (window.location.search === '?list_of_properties' || window.location.search === '?list_of_subscriptions') {
    let urlTabQuery = window.location.search.slice(1)
    let targetTab = Array.from(profileTabs).find(tab => tab.getAttribute('data-tab') === urlTabQuery)
    let targetTabContent = Array.from(profileTabsContent).find(tab => tab.getAttribute('data-tab') === urlTabQuery)

    $(targetTab).siblings().removeClass('active')
    targetTab.classList.add('active')

    $(targetTabContent).siblings().removeClass('active')
    targetTabContent.classList.add('active')
  }

  // Logout
  const profileExitBtn = document.querySelector('.profile-tab-exit')
  if (profileExitBtn) {
    profileExitBtn.addEventListener('click', () => {
      $.ajax({
        url: window.wp_data.ajax_url,
        type: 'POST',
        data: {
          action: 'logOut'
        },
        success: function (response) {
          window.location.replace(window.wp_data.home_url)
        }
      })
    })
  }

  const userInputToggle = document.querySelector('.js-toggle-filter-location')
  if (userInputToggle) {
    userInputToggle.addEventListener('click', () => {
      document.querySelector('.js-filter-location-wrapper').classList.toggle('active')
    })
  }

  const separateNumsArr = document.querySelectorAll('.separate-num')
  separateNumsArr.forEach(function (numEl) {
    numEl.innerHTML = numEl.textContent.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  })

  // Modals
  const openModalHandler = (event, wrapper, popup) => {
    event.preventDefault()
    openModalHelper()
    toggleElement(wrapper)
    toggleElement(popup)
  }

  const closeModalHandler = () => {
    const modalClose = Array.from(document.querySelectorAll('.modal .close'))
    const modalCancel = Array.from(document.querySelectorAll('.modal .cancel'))

    modalClose.forEach(modalCloseEl => {
      modalCloseEl.addEventListener('click', function (event) {
        event.preventDefault()
        event.stopPropagation()
        const parent = this.closest('.modal')
        const content = this.closest('.modal__content')
        closeModalHelper()
        // toggleElement(parent)
        // toggleElement(content)
        parent.classList.remove('opened')
        content.classList.remove('opened')
      })
    })

    modalCancel.forEach(modalCancelEl => {
      modalCancelEl.addEventListener('click', function (event) {
        event.preventDefault()
        const parent = this.closest('.modal')
        const content = this.closest('.modal__content')
        closeModalHelper()
        // toggleElement(parent)
        // toggleElement(content)
        parent.classList.remove('opened')
        content.classList.remove('opened')
      })
    })
  }

  closeModalHandler()

  const regularBuy = document.querySelector('.subscriptions-list__item-subscribe.regular')
  const nationalBuy = document.querySelector('.subscriptions-list__item-subscribe.national')
  const modalSelectStateWrap = document.querySelector('.form-select-state-wrap')
  const mainModalSelectStatePopup = document.querySelector('.form-select-state')

  if (regularBuy) {
    regularBuy.addEventListener('click', event => {
      openModalHandler(event, modalSelectStateWrap, mainModalSelectStatePopup)

      const stateSelect = document.querySelector('select[name="select-state"]')
      const goToPaymentLink = document.querySelector('.go-to-payment')
      let paymentUrl = goToPaymentLink.getAttribute('data-siteURL')
      let paymentProductStateId = goToPaymentLink.getAttribute('data-productStateId')
      let paymentState = stateSelect.value

      goToPaymentLink.href = `${paymentUrl}/cart/?add-to-cart=${paymentProductStateId}&quantity=1&state=${paymentState}`

      stateSelect.addEventListener('change', function () {
        paymentState = this.value
        goToPaymentLink.href = `${paymentUrl}/cart/?add-to-cart=${paymentProductStateId}&quantity=1&state=${paymentState}`
      })
    })
  }

  const enableAutorenewalSubscriptionBtns = document.querySelectorAll('.js-enable-auto-renewal')
  const modalEnableAutorenewalSubscriptionWrap = document.querySelector(
    '.form-profile-enable-autorenewal-subscription-wrap'
  )
  const modalEnableAutorenewalSubscriptionPopup = document.querySelector(
    '.form-profile-enable-autorenewal-subscription'
  )

  enableAutorenewalSubscriptionBtns.forEach(button => {
    button.addEventListener('click', event => {
      openModalHandler(event, modalEnableAutorenewalSubscriptionWrap, modalEnableAutorenewalSubscriptionPopup)
    })
  })

  const disableAutorenewalSubscriptionBtns = document.querySelectorAll('.js-disable-auto-renewal')
  const modalDisableAutorenewalSubscriptionWrap = document.querySelector(
    '.form-profile-disable-autorenewal-subscription-wrap'
  )
  const modalDisableAutorenewalSubscriptionPopup = document.querySelector(
    '.form-profile-disable-autorenewal-subscription'
  )

  disableAutorenewalSubscriptionBtns.forEach(button => {
    button.addEventListener('click', event => {
      openModalHandler(event, modalDisableAutorenewalSubscriptionWrap, modalDisableAutorenewalSubscriptionPopup)
    })
  })

  const modalCheckForSubscriptionWrap = document.querySelector('.form-profile-inquiry-wrap')
  const modalCheckForSubscriptionPopup = document.querySelector('.form-profile-inquiry')

  const modalCheckForStateSubscriptionWrap = document.querySelector('.form-profile-inquiry-state-wrap')
  const modalCheckForStateSubscriptionPopup = document.querySelector('.form-profile-inquiry-state')

  const modalCheckForLoginWrap = document.querySelector('.form-status-wrap')
  const modalCheckForLoginPopup = document.querySelector('.form-status')

  const steps = Array.from(document.querySelectorAll('.form-profile__step'))
  let stepCurrent = null
  const openStep = id => {
    steps.forEach(step => step.classList.remove('active'))
    stepCurrent = document.querySelector(`.form-profile__step[data-step="${id}"]`)
    stepCurrent.classList.add('active')
  }

  function initInquiryBtns(btns) {
    btns.forEach(button => {
      button.addEventListener('click', function (event) {
        if (this.classList.contains('need-subscription')) {
          openModalHandler(event, modalCheckForSubscriptionWrap, modalCheckForSubscriptionPopup)
          return
        } else if (this.classList.contains('regular-subscription') && this.classList.contains('subscribe-closed')) {
          openModalHandler(event, modalCheckForStateSubscriptionWrap, modalCheckForStateSubscriptionPopup)
          return
        } else if (this.classList.contains('guest')) {
          openModalHandler(event, modalCheckForLoginWrap, modalCheckForLoginPopup)

          openStep('create-account')

          $('.js-status-form label.seller').removeClass('selected')
          $('.js-status-form label.seller > .js-radio-status').attr('checked', false)

          $('.js-status-form label.buyer').addClass('selected')
          $('.js-status-form label.buyer > .js-radio-status').attr('checked', true)

          if (localStorage.getItem('role') === 'Seller') {
            $('.form-profile__step-text').hide()
            $('.change-step-btn').val('Create Account')
          } else {
            $('.form-profile__step-text').show()
            $('.change-step-btn').val('Continue')
          }

          return
        }

        const mainModal = document.querySelector('.info')
        const infoLoader = document.querySelector('.info-loader')
        const modalWrap = document.querySelector('.info-wrap')
        const infoModalText = modalWrap.querySelector('.modal__title')
        const infoModalBtn = modalWrap.querySelector('button')
        const propertyItem = event.target.parentNode.parentNode

        infoModalText.textContent = 'Thank you for you interest! We will contact you soon'
        infoModalBtn.textContent = 'Continue'

        modalWrap.classList.add('opened')
        modalWrap.setAttribute('data-property-id', propertyItem.dataset.propertyId)

        openModalHelper()

        const closeInfoModal = () => {
          if (modalWrap.dataset.propertyId !== undefined) {
            if (modalWrap.dataset.propertyId === 'none') {
              modalWrap.classList.remove('opened')
              closeModalHelper()
              modalWrap.removeAttribute('data-property-id')
              return
            }

            $.ajax({
              url: '/wp-admin/admin-ajax.php',
              type: 'POST',
              data: {
                action: 'inquiryProperty',
                data: [
                  {
                    propertyId: modalWrap.dataset.propertyId
                  }
                ]
              },
              beforeSend: () => {
                mainModal.classList.remove('opened')
                infoLoader.classList.add('opened')
              },
              success: response => {
                let isInquiryDone = response.data.status === 'success'

                if (isInquiryDone) {
                  modalWrap.classList.add('checked')
                  window.location = window.location.pathname + '?list_of_properties'
                } else {
                  console.log(response)
                  openErrorNotification()
                }
              },
              error: error => {
                console.log(error)
                openErrorNotification()
              },
              complete: data => {
                modalWrap.classList.remove('opened')

                infoLoader.classList.remove('opened')
                mainModal.classList.add('opened')

                closeModalHelper()
                modalWrap.removeAttribute('data-property-id')
              }
            })
          }
        }

        modalWrap.addEventListener('click', event => {
          if (event.target === modalWrap) {
            closeInfoModal()
          }
        })

        infoModalBtn.addEventListener('click', () => {
          closeInfoModal()
        })
      })
    })
  }

  // Subscription autorenewal
  $('.js-enable-autorenewal-subscription-form').on('submit', function (event) {
    event.preventDefault()

    let enableAutorenewalSubscriptionFormData = $(this).serializeArray()

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: {
        action: 'connectAutomaticSubscription',
        data: enableAutorenewalSubscriptionFormData[0]
      },
      beforeSend: () => {
        $('.js-enable-autorenewal-subscription-form button[type="submit"] .btn-text').hide()
        $('.js-enable-autorenewal-subscription-form button[type="submit"] .btn-loader').show()
      },
      success: response => {
        if (response.status === 200) {
          $('.form-profile-enable-autorenewal-subscription-wrap').removeClass('opened')
          $('.form-profile-enable-autorenewal-subscription').removeClass('opened')

          Swal.fire({
            icon: 'success',
            title: 'You have successfully activated subscription auto-renewal!',
            showConfirmButton: false,
            timer: 3000
          })

          window.location = `${window.location.origin}/profile/?list_of_subscriptions`
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Something went wrong!',
            text: 'Try again later.',
            showConfirmButton: false,
            timer: 3000
          })

          console.log(response)
          $('.js-enable-autorenewal-subscription-form button[type="submit"] .btn-text').show()
          $('.js-enable-autorenewal-subscription-form button[type="submit"] .btn-loader').hide()
        }
      },
      error: error => {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong!',
          text: 'Try again later.',
          showConfirmButton: false,
          timer: 3000
        })

        console.log(error)
        $('.js-enable-autorenewal-subscription-form button[type="submit"] .btn-text').show()
        $('.js-enable-autorenewal-subscription-form button[type="submit"] .btn-loader').hide()
      },
      complete: data => {
        $('.form-profile-enable-autorenewal-subscription-wrap').removeClass('opened')
        $('.form-profile-enable-autorenewal-subscription').removeClass('opened')

        Swal.fire({
          icon: 'success',
          title: 'You have successfully activated subscription auto-renewal!',
          showConfirmButton: false,
          timer: 3000
        })

        window.location = `${window.location.origin}/profile/?list_of_subscriptions`
      }
    })
  })

  $('.js-disable-autorenewal-subscription-form').on('submit', function (event) {
    event.preventDefault()

    let disableAutorenewalSubscriptionFormData = $(this).serializeArray()

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: {
        action: 'connectAutomaticSubscription',
        data: disableAutorenewalSubscriptionFormData[0]
      },
      beforeSend: () => {
        $('.js-disable-autorenewal-subscription-form button[type="submit"] .btn-text').hide()
        $('.js-disable-autorenewal-subscription-form button[type="submit"] .btn-loader').show()
      },
      success: response => {
        if (response.status === 200) {
          $('.form-profile-disable-autorenewal-subscription-wrap').removeClass('opened')
          $('.form-profile-disable-autorenewal-subscription').removeClass('opened')

          Swal.fire({
            icon: 'success',
            title: 'You have successfully turned off autorenewal of your subscription!',
            showConfirmButton: false,
            timer: 3000
          })

          window.location = `${window.location.origin}/profile/?list_of_subscriptions`
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Something went wrong!',
            text: 'Try again later.',
            showConfirmButton: false,
            timer: 3000
          })

          console.log(response)
          $('.js-disable-autorenewal-subscription-form button[type="submit"] .btn-text').show()
          $('.js-disable-autorenewal-subscription-form button[type="submit"] .btn-loader').hide()
        }
      },
      error: error => {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong!',
          text: 'Try again later.',
          showConfirmButton: false,
          timer: 3000
        })

        console.log(error)
        $('.js-disable-autorenewal-subscription-form button[type="submit"] .btn-text').show()
        $('.js-disable-autorenewal-subscription-form button[type="submit"] .btn-loader').hide()
      },
      complete: data => {
        $('.form-profile-disable-autorenewal-subscription-wrap').removeClass('opened')
        $('.form-profile-disable-autorenewal-subscription').removeClass('opened')

        Swal.fire({
          icon: 'success',
          title: 'You have successfully turned off autorenewal of your subscription!',
          showConfirmButton: false,
          timer: 3000
        })

        window.location = `${window.location.origin}/profile/?list_of_subscriptions`
      }
    })
  })
}
